import { reactive, watchEffect } from 'vue'
/**
 * @typedef {Object} RAFTime
 * @property {number} delta
 * @property {number} timestamp
 */

/**
 * @typedef {Object} ElasticNumber
 * @property {number} value
 * @property {number} speed
 * @property {number} target
 * @property {Function} update
 */

/**
 *
 * @param {import('node_modules/@vue/reactivity/dist/reactivity').Ref<number>|number} value
 * @param {import('node_modules/@vue/reactivity/dist/reactivity').Ref<number>|number} speed
 * @param {RAFTime} time
 * @returns {ElasticNumber} the elastic number instance
 */
export const useElasticNumber = (value = 0, speed = 3, time) => {
  const data = reactive({
    value,
    speed,
    target: value,
    update: (deltaTime = 0) => {
      const dist = data.target - data.value
      data.value += dist * (data.speed * deltaTime)
    }
  })
  if (time) {
    watchEffect(() => {
      data.update(time.deltaTime, time.timestamp)
    })
  }
  return data
}

export default useElasticNumber
